

export default class MapUtils {

  /**
   * Calculate the distance in metres between two longitude/latitude points
   * Approximation, not designed to be 100% accurate
   * Based on Haversine Formula & code from:
   * http://www.movable-type.co.uk/scripts/latlong.html
   * https://en.wikipedia.org/wiki/Haversine_formula
   * Synchronous
   * 
   * @param {Number} longitudeA - Longitude value of point A
   * @param {Number} latitudeA - Latitude value of point A
   * @param {Number} longitudeB - Longitude value of point B
   * @param {Number} latitudeB - Latitude value of point B
   * @return {Number} Returns approximate distance in metres between the two points
   */
  static calculateDistanceBetweenPoints(longitudeA, latitudeA, longitudeB, latitudeB) {
    var R = 6378.137; // Radius of earth in KM
    var dLat = latitudeB * Math.PI / 180 - latitudeA * Math.PI / 180;
    var dLon = longitudeB * Math.PI / 180 - longitudeA * Math.PI / 180;
    var a = Math.sin(dLat/2) * Math.sin(dLat/2) +
    Math.cos(latitudeA * Math.PI / 180) * Math.cos(latitudeB * Math.PI / 180) *
    Math.sin(dLon/2) * Math.sin(dLon/2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
    var d = R * c;
    return d * 1000;
  }

}
